import { api } from '@marketplace-web/core-api/core-api-client-util'

import { ConversationResp } from '../types/conversation'

export const declineComplaintResolved = (conversationId: number | string) =>
  api.patch<ConversationResp>(`/conversations/${conversationId}/complaint/refuse_resolved`)

export const confirmComplaintResolved = (conversationId: number | string) =>
  api.patch<ConversationResp>(`/conversations/${conversationId}/complaint/confirm_resolved`)
